import i18n from '../i18n';
import React from 'react';

interface State {
  hasError: boolean;
}

/**
 * Top-level error boundary. Catches render errors in any lazy page so a single
 * component throw shows a recoverable fallback instead of white-screening the app.
 * Fallback uses inline styles (no MUI) so it renders even if the theme layer fails.
 */
class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('UI ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            padding: 24,
            textAlign: 'center'
          }}
        >
          <h1 style={{ fontSize: 22, marginBottom: 8, color: '#1a1a1a' }}>{i18n.t('Bir şeyler ters gitti')}</h1>
          <p style={{ color: '#666', marginBottom: 20 }}>
            {i18n.t('Sayfa yüklenirken beklenmeyen bir hata oluştu.')}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              fontSize: 15,
              background: '#1976D2',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer'
            }}
          >
            {i18n.t('Sayfayı yenile')}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
